


import { setGetMailingStatisticsCountReplenishmentAction } from '../action';
import { getMailingStatisticsCountReplenishment } from '../api/getMailingStatisticsCountReplenishment';

export const setGetMailingStatisticsCountReplenishment = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsCountReplenishment({
                ...params,
                status: 'paid'
            });

            dispatch(setGetMailingStatisticsCountReplenishmentAction(data));
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}